/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { Text } from '../../atoms/Text';
import './PaneStyles.scss';
const BASE_CLASS = 'qmb-ui-pane';
export function Pane({ title, subtitle, headerRight, children, footer, className }) {
    return (React.createElement("div", { className: classNames(BASE_CLASS, className) },
        React.createElement("div", { className: "pane__header" },
            React.createElement("div", { className: "pane__header-content" },
                React.createElement(Text, { as: "h3", variant: "small", className: "pane__title" }, title),
                subtitle && (React.createElement(Text, { variant: "body", className: "pane__subtitle" }, subtitle))),
            headerRight != null && React.createElement("div", { className: "pane__header-right" }, headerRight)),
        React.createElement("div", { className: "pane__body" }, children),
        footer != null && React.createElement("div", { className: "pane__footer" }, footer)));
}
